import actionTypes from '../actions'

const initialState = {
  user_contacts: {
    phone: '',
    email: '',
  },
  alerts: null,
}

const alertTabReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATEUSERALERTS:
      state = {
        ...state,
        user_contacts: payload.user_contacts,
        alerts: payload.alerts,
      }
      break
    default:
      return state
  }
  return state
}

export default alertTabReducer
